<div class="flex flex-col gap-medpace">
    @if (this.paymentRequestDetails.value(); as paymentRequestDetails) {
        @let modalContent = this.modalContent();
        <medpace-labeled-text [label]="'Current Status'" [text]="currentStatus() ?? ''" />

        @let newStatus = modalContent.newStatus;
        @if (newStatus) {
            <div class="flex flex-col gap-medpace">
                <mds-dropdown
                    [closeOnPageScroll]="false"
                    [formCtrl]="formGroup().controls.newStatusId"
                    [appearance]="'outline'"
                    [label]="'Change Status to'"
                    [placeholder]="'Please Select Status'"
                    [options]="options() ?? []"
                    [id]="'statusDropdown'"
                    [required]="true"
                ></mds-dropdown>

                @for (note of newStatus.notes; track note) {
                    <span>{{ note }}</span>
                }
            </div>
        }

        @let totalAuthorized = modalContent.totalAuthorized;
        @if (totalAuthorized !== null) {
            <div class="flex flex-row gap-medpace">
                @if (totalAuthorized.inPatientsCurrency === true) {
                    <div class="flex-1">
                        <medpace-labeled-text
                            [label]="`Total Authorized (${paymentRequestDetails.patient.preferredCurrency})`"
                            [text]="
                                paymentRequestDetails.totalAuthorizedAmountPatientsCurrency | number: '1.2-2' : 'en-US'
                            "
                        />
                        <!-- display patients currency PLN -->
                    </div>
                }
                @if (totalAuthorized.inUSD === true) {
                    <div class="flex-1">
                        <medpace-labeled-text
                            [label]="'Total Authorized (USD)'"
                            [text]="paymentRequestDetails.totalAuthorizedAmountUsd | number: '1.2-2' : 'en-US'"
                        />
                    </div>
                }
            </div>
        }

        @if (modalContent.deductedForm !== null) {
            @if (postCurrencyConversionMigration() === false) {
                <medpace-labeled-text
                    [label]="`Total Authorized (${paymentRequestDetails.totalCurrency})`"
                    [text]="(paymentRequestDetails.totalAuthorizedAmount | number: '1.2-2' : 'en-US') ?? 'Unspecified'"
                />
            } @else {
                <medpace-labeled-text
                    [label]="`Total Authorized (${paymentRequestDetails.patient.preferredCurrency})`"
                    [text]="
                        (paymentRequestDetails.totalAuthorizedAmountPatientsCurrency | number: '1.2-2' : 'en-US') ??
                        'Unspecified'
                    "
                />
            }

            <div class="flex flex-row gap-medpace *:flex-1">
                @let deductedCurrency = this.deductedCurrency();
                <mds-text-field
                    [id]="'totalToBeDeductedField'"
                    [formCtrl]="formGroup().controls.deductedFormGroup.controls.deducted"
                    [appearance]="'outline'"
                    [placeholder]="'Type here...'"
                    [label]="
                        isDeductedCurrencyUsd() ? 'Deducted (USD)' : 'Deducted (' + deductedCurrency?.isocode + ')'
                    "
                    [inputType]="'decimal'"
                ></mds-text-field>

                @if (deductedCurrency && !isDeductedCurrencyUsd()) {
                    <medpace-labeled-text
                        [id]="'totalToBeDeductedFieldUSD'"
                        [label]="'Deducted (USD)'"
                        [text]="(deductedUsd.value() | number: '1.2-2' : 'en-US') ?? '-'"
                    />
                }
            </div>
        }

        <mds-textarea
            [label]="'Additional Information'"
            [placeholder]="'Type here...'"
            [appearance]="'outline'"
            [id]="'additionalInfo'"
            [autoSize]="true"
            [cdkAutosizeMinRows]="8"
            [cdkAutosizeMaxRows]="8"
            [formCtrl]="formGroup().controls.additionalInfo"
        />

        <div class="flex flex-row gap-medpace justify-end">
            @let cancelButton = modalContent.cancelButton;
            <mds-button
                id="cancel-btn"
                label="Cancel"
                (clickEvent)="cancelButton.onClick()"
                variant="outline"
            ></mds-button>
            @let confirmButton = modalContent.confirmButton;
            <mds-button
                id="confirm-btn"
                label="Confirm"
                (clickEvent)="confirmButton.onClick()"
                [color]="'primary'"
                [variant]="'filled'"
                [disabled]="confirmButton.disabled"
            ></mds-button>
        </div>
    }
</div>
